type MobileIssueVideoLandingState = {
  showLandingPage: boolean;
  showVideoUpload: boolean;
};

/**
 * Keeps the phone landing page live while independently gating the upload flow.
 */
export const getMobileIssueVideoLandingState = ({
  isMobile,
  isVideoUploadEnabled,
}: {
  isMobile: boolean;
  isVideoUploadEnabled: boolean;
}): MobileIssueVideoLandingState => ({
  showLandingPage: isMobile,
  showVideoUpload: isMobile && isVideoUploadEnabled,
});
